function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { ButtonSecondary, Module, ModuleContent, ModuleBody, ModuleFooter, ModuleGrid, ModuleTitle, ModuleDescription, ModuleAvatar } from "../";
import { FormattedMessage } from "react-intl";
import messages from "./ModuleUserProfile.messages";

import "./ModuleUserProfile.scss";

var UserInfo = function (_Component) {
    _inherits(UserInfo, _Component);

    function UserInfo() {
        var _temp, _this, _ret;

        _classCallCheck(this, UserInfo);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onLogout = function (event) {

            if (_this.props.onLogout) {
                _this.props.onLogout(_this.props, event);
            }
        }, _this.renderAvatar = function () {
            var imageUrl = _this.props.user.imageUrl;


            if (!imageUrl) {
                return false;
            }

            return React.createElement(ModuleAvatar, { imageUrl: imageUrl });
        }, _this.renderFooter = function () {
            var _this$props = _this.props,
                logoutUrl = _this$props.logoutUrl,
                app = _this$props.app;
            var version = app.version,
                createdAt = app.createdAt,
                updatedAt = app.updatedAt;

            var date = createdAt || updatedAt || "";

            return React.createElement(
                ModuleFooter,
                null,
                React.createElement(
                    "p",
                    { className: "app-version" },
                    React.createElement(
                        "strong",
                        null,
                        React.createElement(FormattedMessage, messages['version'])
                    ),
                    " ",
                    version
                ),
                React.createElement(
                    "p",
                    { className: "app-date" },
                    React.createElement(
                        "strong",
                        null,
                        React.createElement(FormattedMessage, messages['date'])
                    ),
                    " ",
                    date
                ),
                React.createElement(ButtonSecondary, { intlLabel: "logout", label: "Log out", url: logoutUrl, onClick: function onClick(event) {
                        return _this.onLogout(event);
                    } })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    UserInfo.prototype.render = function render() {
        var _props$user = this.props.user,
            name = _props$user.name,
            email = _props$user.email;


        return React.createElement(
            Module,
            { moduleType: "user-profile", moduleShadow: false },
            React.createElement(
                ModuleContent,
                null,
                this.renderAvatar(),
                React.createElement(
                    ModuleBody,
                    null,
                    React.createElement(ModuleTitle, { title: name }),
                    React.createElement(ModuleDescription, { description: email })
                )
            ),
            this.renderFooter()
        );
    };

    return UserInfo;
}(Component);

export default UserInfo;